import React from 'react';

const CancellationRefund: React.FC = () => {
  return (
    <div className="cancellation-refund-page" style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Header Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '4rem 0 2rem',
        marginBottom: '3rem'
      }}>
        <div className="container">
          <div className="text-center text-white">
            <h1 className="display-4 fw-bold mb-3">
              <i className="fas fa-sync-alt me-3"></i>
              Subscription Cancellation & Refund Policy
            </h1>
            <p className="lead mb-2">
              Understand our policies regarding subscription cancellations and refunds.
            </p>
            <p className="mb-0 opacity-75">
              <small>BRAINTONICA EDTECH LLP — WiZiAi Platform</small>
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mb-5">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-5">
            
            {/* Introduction */}
            <section className="mb-5">
              <div className="alert alert-info border-0 shadow-sm">
                <h4 className="alert-heading mb-3">
                  <i className="fas fa-info-circle me-2"></i>
                  Introduction
                </h4>
                <p className="mb-0">
                  This Subscription Cancellation and Refund Policy ("Policy") governs the terms and conditions for cancellation of paid subscription plans for the WiZiAi platform (the "Platform") offered by <strong>BRAINTONICA EDTECH LLP</strong> ("WiZiAi", "we", "our", or "us"). By subscribing to any paid plan, you ("User") agree to the terms set forth in this Policy.
                </p>
              </div>
            </section>

            {/* Nature of Subscription */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-star me-2"></i>
                1. Nature of Subscription
              </h2>
              <ol className="text-muted">
                <li className="mb-2">WiZiAi offers subscription-based access to premium features, test series, AI-powered analytics, personalized mentoring, and performance tools.</li>
                <li className="mb-0">
                  Subscriptions may be purchased via:
                  <ul className="mt-2">
                    <li>The WiZiAi website (www.wiziai.com)</li>
                    <li>The WiZiAi Android app on Google Play Store</li>
                    <li>The WiZiAi iOS app on Apple App Store</li>
                  </ul>
                </li>
              </ol>
            </section>

            {/* Cancellation Policy */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-times-circle me-2"></i>
                2. Cancellation Policy
              </h2>
              <div className="row g-3 mb-3">
                <div className="col-md-6">
                  <div className="card border-primary h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-check text-success me-2"></i>You Can Cancel Anytime</h5>
                      <p className="mb-0 small text-muted">Users may cancel their subscription at any time through the relevant app store or account settings.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-info h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-redo text-info me-2"></i>Prevents Auto-Renewal</h5>
                      <p className="mb-0 small text-muted">Cancellation will prevent automatic renewal of the subscription for the next billing cycle.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-success h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-clock text-success me-2"></i>Access Until Period Ends</h5>
                      <p className="mb-0 small text-muted">Access to paid features will continue until the end of the current billing period.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-warning h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-exclamation-triangle text-warning me-2"></i>No Refund on Cancellation</h5>
                      <p className="mb-0 small text-muted">Cancellation does not entitle the user to a refund for any part of the current billing cycle.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="alert alert-warning border-0 mb-0">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Important:</strong> No prorated or partial refunds will be issued for unused days, test attempts, or features.
              </div>
            </section>

            {/* No Refund Policy */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-ban me-2"></i>
                3. No Refund Policy
              </h2>
              <div className="alert alert-danger border-0 shadow-sm mb-3">
                <h5 className="fw-bold mb-2">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  All Payments Are Final and Non-Refundable
                </h5>
                <p className="mb-0">All payments made for subscription plans are final and non-refundable under normal circumstances.</p>
              </div>
              
              <p className="text-muted mb-2">WiZiAi does not provide refunds under the following circumstances:</p>
              <ul className="text-muted">
                <li className="mb-2"><i className="fas fa-times text-danger me-2"></i>User cancels the subscription voluntarily</li>
                <li className="mb-2"><i className="fas fa-times text-danger me-2"></i>User fails to use the subscribed service during the subscription period</li>
                <li className="mb-2"><i className="fas fa-times text-danger me-2"></i>User experiences dissatisfaction arising from AI-generated recommendations or test results</li>
                <li className="mb-2"><i className="fas fa-times text-danger me-2"></i>Subscription was made by mistake or without awareness of its nature</li>
                <li className="mb-2"><i className="fas fa-times text-danger me-2"></i>Account termination due to violation of Terms and Conditions</li>
                <li className="mb-0"><i className="fas fa-times text-danger me-2"></i>Subscription is canceled immediately after purchase</li>
              </ul>
            </section>

            {/* Exceptions */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-clipboard-check me-2"></i>
                4. Exceptions (if applicable)
              </h2>
              <p className="text-muted mb-3">
                WiZiAi may, at its sole discretion, consider a refund or credit only in exceptional cases, such as:
              </p>
              <div className="row g-3 mb-3">
                <div className="col-md-4">
                  <div className="card bg-light border-0 h-100">
                    <div className="card-body text-center">
                      <i className="fas fa-copy text-primary fa-2x mb-3"></i>
                      <h5 className="h6 fw-bold">Duplicate Transactions</h5>
                      <p className="mb-0 small text-muted">Due to technical error</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card bg-light border-0 h-100">
                    <div className="card-body text-center">
                      <i className="fas fa-bug text-danger fa-2x mb-3"></i>
                      <h5 className="h6 fw-bold">Payment Errors</h5>
                      <p className="mb-0 small text-muted">Processing errors by our systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card bg-light border-0 h-100">
                    <div className="card-body text-center">
                      <i className="fas fa-gavel text-warning fa-2x mb-3"></i>
                      <h5 className="h6 fw-bold">Legal Obligation</h5>
                      <p className="mb-0 small text-muted">Required by applicable law</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="alert alert-success border-0 mb-0">
                <i className="fas fa-clock me-2"></i>
                Such cases must be reported within <strong>7 days</strong> of payment via email to <a href="mailto:support@wiziai.com" className="alert-link">support@wiziai.com</a> with proof of transaction.
              </div>
            </section>

            {/* Renewal */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-redo-alt me-2"></i>
                5. Renewal and Auto-Renewal
              </h2>
              <ol className="text-muted">
                <li className="mb-2">Subscriptions purchased through app stores are managed by the respective stores (Google Play / Apple App Store).</li>
                <li className="mb-2">
                  <strong className="text-dark">To avoid renewal</strong>, the user must cancel auto-renewal <span className="badge bg-warning text-dark">at least 24 hours</span> before the end of the current period.
                </li>
                <li className="mb-0">Failure to cancel within the required time frame will result in automatic renewal and billing for the next cycle.</li>
              </ol>
            </section>

            {/* Changes to Policy */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-sync me-2"></i>
                6. Changes to Policy
              </h2>
              <p className="text-muted mb-0">
                WiZiAi reserves the right to modify this Policy at any time. Any changes will be communicated via the Platform or by email. Continued use of the Platform after such notice constitutes acceptance of the updated Policy.
              </p>
            </section>

            {/* Contact */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-envelope me-2"></i>
                7. Contact
              </h2>
              <p className="text-muted mb-3">For cancellation support or questions, please contact:</p>
              <div className="card bg-light border-0">
                <div className="card-body">
                  <p className="mb-2"><strong>BRAINTONICA EDTECH LLP</strong></p>
                  <p className="mb-0">Email: <a href="mailto:support@wiziai.com" className="text-decoration-none">support@wiziai.com</a></p>
                </div>
              </div>
            </section>

            {/* Important Notice */}
            <section className="mb-0">
              <div className="card border-danger">
                <div className="card-header bg-danger text-white">
                  <h4 className="mb-0">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    8. Important Notice
                  </h4>
                </div>
                <div className="card-body">
                  <p className="mb-0 fw-bold">
                    By purchasing a subscription plan on WiZiAi, you acknowledge that you have read, understood, and agreed to this No Refund Policy. Once a subscription is purchased, no refunds or cancellations will be processed under any circumstances, except as required by applicable law.
                  </p>
                </div>
              </div>
            </section>

          </div>
          
          {/* Footer */}
          <div className="card-footer bg-light text-center py-4">
            <p className="mb-3 text-muted">
              <i className="fas fa-file-pdf text-danger me-2"></i>
              Need a PDF copy of this policy?
            </p>
            <a 
              href="/cancellation_and_refund.pdf" 
              download="WiziAI_Cancellation_Refund_Policy.pdf"
              className="btn btn-primary me-3"
              style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                border: 'none'
              }}
            >
              <i className="fas fa-download me-2"></i>
              Download PDF
            </a>
            <a 
              href="/cancellation_and_refund.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline-secondary"
            >
              <i className="fas fa-external-link-alt me-2"></i>
              Open PDF
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationRefund;
